// extracted by mini-css-extract-plugin
export default {"container":"LearningPathCard_container__oKOkn","containerMobile":"LearningPathCard_containerMobile__kL+DL","infoContainer":"LearningPathCard_infoContainer__rDxHb"};